module.exports = __webpack_public_path__ + "static/media/man-in-supermarket.d0f0f744.jpg";